export const LOGIN_REGISTER_SUCCESS = "registerSuccess";
export const LOGIN_VERIFY_SUCCESS = "verifySuccess";
export const LOGIN_PASSWORD_RESET_SUCCESS = "paswordResetSuccess";
export const PAYMENT_PAYMENT_ID = "identifier";
export const PAYMENT_SOURCE = "source";
export const ORDER_PAYMENT_ID = "payment";
export const ORDER_PAYMENT_SUCCESS = "success";
export const SHIPMENT_PAYMENT_ID = "paymentId";
export const SHIPMENT_PAYMENT_SUCCESS = "isSuccess";
export const ORDER_AFFILIATE_ID = "affiliateId";
export const ORDER_RECEIVER_INFO = "receiver";
export const ORDER_SHIPMENT_ID = "id";
export const ORDER_CREATION_SUCCESS = "isCreationSuccess";
export const RDL_ORDER_SUCCESS = "success";
